/* Used for push notifications, cookies and popups. */
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Transition from 'react-transition-group/Transition';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Notification.scss';

class Notification extends Component {
	campaignCycle = false;

	constructor(props) {
		super(props);

		this.notificationInner = React.createRef();
		this.notificationBanner = React.createRef();

		this.state = {
			notificationIndex: 0,
		};
	}

	componentDidMount() {
		const { setup, type, content = [] } = this.props;
		const started = window.performance.now();
		const notifications = content.filter((n) => n?.text && ((n.countryRestrict && n.countryRestrict.indexOf(setup.country) !== -1) || !n.countryRestrict));

		const initiateSiteListeners = () => {
			if (!notifications && started + 2000 < window.performance.now()) {
				setTimeout(initiateSiteListeners, 200);
			}

			if (notifications && notifications.length > 1 && type === 'campaign') {
				this.campaignCycle = setInterval(() => {
					this.setState((prevState) => ({ notificationIndex: prevState.notificationIndex + 1 }));
				}, 4000);
			}
		};

		initiateSiteListeners();
	}

	componentWillUnmount() {
		clearInterval(this.campaignCycle);
	}

	render() {
		const { type, content, setup } = this.props;

		if (!content) return null;
		const notifications = content.filter((n) => n?.text && ((n.countryRestrict && n.countryRestrict.indexOf(setup.country) !== -1) || !n.countryRestrict));

		return (
			<div className={[s.notification, s[`notification__${type}`]].join(' ')}>
				{
					notifications.map((item) => {
						const notificationName = urlify(item.name);
						const notificationInnerClasses = [s.notification_inner, (item.removeText ? [s.notification_inner__closeText] : null)];

						let innerTextContent = translate(setup, item?.text);
						const innerTextLength = Math.round(innerTextContent.length / 40);

						if (type === 'campaign') {
							innerTextContent = `${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}`;
						}

						innerTextContent = `<div>${innerTextContent}</div>`;

						return (
							<Transition in={item.removed !== true} timeout={300} key={notificationName} unmountOnExit>
								{(state) => (
									<div ref={this.notificationInner} className={[...notificationInnerClasses, s[`notification_inner__${state}`]].join(' ')}>
										<div className={s.notification_inner_wrapper}>
											<div ref={this.notificationBanner} className={[s.notification_inner_text, s[`notification_inner_text__${innerTextLength}`]].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(innerTextContent) }} />
										</div>
									</div>
								)}
							</Transition>
						);
					})
				}
			</div>
		);
	}
}

export default hot(module)(Notification);
